export const messages = {
  invalid_credentials: 'Invalid credentials',
};
